import { observer } from "mobx-react";
import React from "react";
import { StyleSheet } from "react-native";
import { Icon } from "~/components/Icon";
import { Layout } from "~/components/Layout";
import { Modal } from "~/components/Modal";
import { Spacer } from "~/components/Spacer";
import { Pressable } from "~/components/V2/Pressable";
import { BrandText } from "~/components/V2/Text/BrandText";
import { View } from "~/components/V2/View";
import { styleConstantsV2 } from "~/style/styleConstantsV2";
import { SaveButton } from "./SaveButton";
import type { PropsWithChildren } from "react";

const S = StyleSheet.create({
  mobileContainer: {
    backgroundColor: styleConstantsV2.colorPrimary,
    paddingHorizontal: 24,
    paddingTop: 64,
    paddingBottom: 80,
  },
  cardStyle: {
    backgroundColor: styleConstantsV2.colorPrimary,
    paddingHorizontal: 88,
    paddingVertical: 56,
    paddingBottom: 80,
    minHeight: 400,
    flex: "unset" as any,
  },
  pointerEventsNone: {
    pointerEvents: "none",
  },
  closeIconContainer: {
    margin: 24,
  },
});

export const EditPetModal = observer(function EditPetModal({
  onClose,
  title,
  children,
  onSave,
}: PropsWithChildren<{
  onClose: () => void;
  onSave: () => Promise<void>;
  title: string;
}>) {
  return (
    <Modal>
      <View flex colorBackgroundBackdrop>
        <Layout
          mobileContainerStyle={S.mobileContainer}
          cardStyle={S.cardStyle}
          webContainerStyle={{
            paddingVertical: 72,
          }}
        >
          {/* Close Button */}
          <View absoluteTopRight>
            <Pressable onPress={onClose} style={S.closeIconContainer}>
              <Icon
                name="close"
                size={32}
                color={styleConstantsV2.colorWhite}
              />
            </Pressable>
          </View>
          {/* Title */}
          <BrandText sizeH3 weightBold colorWhite style={S.pointerEventsNone}>
            {title}
          </BrandText>
          <Spacer small />
          {children}
          <Spacer extraExtraLarge />
          <SaveButton onPress={onSave} />
        </Layout>
      </View>
    </Modal>
  );
});
